/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrentUserDetail } from './CurrentUserDetail';
import {
    CurrentUserDetailFromJSON,
    CurrentUserDetailFromJSONTyped,
    CurrentUserDetailToJSON,
    CurrentUserDetailToJSONTyped,
} from './CurrentUserDetail';

/**
 * 
 * @export
 * @interface GetCurrentUser200Response
 */
export interface GetCurrentUser200Response {
    /**
     * 
     */
    data?: CurrentUserDetail;
}

/**
 * Check if a given object implements the GetCurrentUser200Response interface.
 */
export function instanceOfGetCurrentUser200Response(value: object): value is GetCurrentUser200Response {
    return true;
}

export function GetCurrentUser200ResponseFromJSON(json: any): GetCurrentUser200Response {
    return GetCurrentUser200ResponseFromJSONTyped(json, false);
}

export function GetCurrentUser200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentUser200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CurrentUserDetailFromJSON(json['data']),
    };
}

export function GetCurrentUser200ResponseToJSON(json: any): GetCurrentUser200Response {
    return GetCurrentUser200ResponseToJSONTyped(json, false);
}

export function GetCurrentUser200ResponseToJSONTyped(value?: GetCurrentUser200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CurrentUserDetailToJSON(value['data']),
    };
}

